// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__C5B7I","switch":"styles_switch__dvljW","signIcon":"styles_signIcon__j6dgF","awardIcon":"styles_awardIcon__yGiVI"};